var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_679_25775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6583 17.5L2.5 9.34167V11.0083C2.5 11.45 2.675 11.875 2.99167 12.1833L9.48333 18.675C10.1333 19.325 11.1917 19.325 11.8417 18.675L17.0167 13.5C17.6667 12.85 17.6667 11.7917 17.0167 11.1417L10.6583 17.5Z",
    fill: "#434455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48333 14.5083C10.1333 15.1583 11.1917 15.1583 11.8417 14.5083L17.0167 9.33333C17.6667 8.68333 17.6667 7.625 17.0167 6.975L10.525 0.483333C10.2085 0.174418 9.78397 0.00103777 9.34167 0L4.16667 0C3.25 0 2.5 0.75 2.5 1.66667V6.84167C2.5 7.28333 2.675 7.70833 2.99167 8.01667L9.48333 14.5083ZM6.04167 2.5C6.31793 2.5 6.58289 2.60975 6.77824 2.8051C6.97359 3.00045 7.08333 3.2654 7.08333 3.54167C7.08333 3.81793 6.97359 4.08289 6.77824 4.27824C6.58289 4.47359 6.31793 4.58333 6.04167 4.58333C5.7654 4.58333 5.50045 4.47359 5.3051 4.27824C5.10975 4.08289 5 3.81793 5 3.54167C5 3.2654 5.10975 3.00045 5.3051 2.8051C5.50045 2.60975 5.7654 2.5 6.04167 2.5Z",
    fill: "#434455"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_679_25775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.c1a25db7ce96f06f08a2e9c7aa55294f.svg";
export { ForwardRef as ReactComponent };